module.exports = __webpack_public_path__ + "img/HC.1809948c.png";